import type { ActiveTab } from './types';

const KNOWN_ACTIVE_TABS: ReadonlySet<ActiveTab> = new Set<ActiveTab>([
  'overview',
  'analyst-ratings',
  'guidance',
  'holdings',
  'government-trades',
  'dividends',
  'earnings',
  'events',
  'news',
  'short-interest',
  'insider-trades',
  'option-chain',
  'unusual-options',
  'report',
]);

export const deriveQuoteActiveTabFromPathname = (pathname: string | null | undefined): ActiveTab => {
  if (!pathname) return 'overview';
  const segments = pathname.split('/').filter(Boolean);
  if (segments[0] !== 'quote' || segments.length < 3) return 'overview';
  const candidate = segments[2] as ActiveTab;
  return KNOWN_ACTIVE_TABS.has(candidate) ? candidate : 'overview';
};
